// Multiple places in the UI need to know whether to show an Operation.
import { Operation } from "./Operation";
// import { remoteVariables } from './CommonGlobals';

export function shouldShowOp(op: Operation): boolean {
    switch (op) {
        default:
            // After a rollback, there may be an operation in the user's toolbox
            // that existed in the new version but not the old version we rolled
            // back to.  In that case, we should hide it.
            return Object.values(Operation).includes(op);
    }
}